export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10769.b090527b.jpg";